import React from 'react';
import markDark from '../images/logodark.png';        // white LF mark  (for dark backgrounds)
import wordDark from '../images/logolongdark.png';    // white LINCFOLIO wordmark
import markLight from '../images/logo.png';           // black LF mark  (for light backgrounds)
import wordLight from '../images/logolong.png';       // black LINCFOLIO wordmark

/**
 * One brand lockup used everywhere: LF mark + LINCFOLIO name.
 * variant: 'dark'  -> white logo for dark backgrounds (sidebar, app)
 *          'light' -> black logo for light backgrounds (login / register pages)
 * iconOnly: show just the LF mark (collapsed sidebar)
 */
export default function BrandLogo({ variant = 'dark', height = 28, iconOnly = false, style }) {
  const mark = variant === 'dark' ? markDark : markLight;
  const word = variant === 'dark' ? wordDark : wordLight;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: Math.round(height * 0.38), ...style }}>
      <img src={mark} alt="Lincfolio logo" style={{ height, width: 'auto', display: 'block' }} />
      {!iconOnly && (
        <img src={word} alt="Lincfolio" style={{ height: Math.round(height * 0.62), width: 'auto', display: 'block' }} />
      )}
    </div>
  );
}